export default __webpack_public_path__ + "static/media/url-icon.ce7a9be2.svg";